import React, { Component } from 'react';
import _ from 'lodash';
import ConfigurationPropertyList from './ConfigurationPropertyList';
import {
  ConfigType,
  Configuration,
  ConfigurationElement,
  ConfigurationMap,
  ConfProp,
} from '../../types/rest/configurationsType';
import { showToastNotification } from '../../store/ui/toasts/toastsActions';
import { ToastType } from '../../store/ui/toasts/toastsTypes';
import { connect } from 'react-redux';

interface ConfigurationDetailProps {
  configuration: Configuration;
  onSave: (configurationMap: ConfigurationMap, duplicatesFound: boolean) => void;
  invalidField: boolean;
  inInitialState: boolean;
  setInInitialState: (isInitial: boolean) => void;
  dirtyPropsFound: boolean;
  resetDirtyPropsFound: () => void;
}

interface LocalState {
  confPropsMap: ConfProp[];
}

export const createConfPropList = (configurationMap: ConfigurationMap): ConfProp[] => {
  const list = _.map(configurationMap, (value, key) => {
    return { key: key, isDirty: false, isValid: true, configuration: value } as ConfProp;
  });
  if (list.length === 0) {
    const defaultConfigEl: ConfigurationElement = { type: 'string', value: '' };
    list.push({ key: '', configuration: defaultConfigEl, isDirty: false, isValid: false });
  }
  return list;
};

export class ConfigurationDetail extends Component<AllProps> {
  state: LocalState = {
    confPropsMap: createConfPropList(this.props.configuration.configurationMap),
  };

  handleAddNewStringValue = (type: ConfigType) => {
    let newItems: ConfProp[] = [{ key: '', configuration: { type: type }, isDirty: false, isValid: false }];

    if (type === 'messaging') {
      const existingKeys = new Set(this.state.confPropsMap.map(item => item.key));
      const MESSAGING_PROPERTIES: ConfProp[] = [
        { key: 'MSG_HOST_NAME', configuration: { type: 'string' }, isDirty: false, isValid: true },
        { key: 'MSG_HOST_PORT', configuration: { type: 'string' }, isDirty: false, isValid: true },
        { key: 'MSG_BROKER_CHANNEL', configuration: { type: 'string' }, isDirty: false, isValid: true },
        { key: 'MSG_BROKER_QUEUE_MNG', configuration: { type: 'string' }, isDirty: false, isValid: true },
        { key: 'MSG_USERNAME', configuration: { type: 'string' }, isDirty: false, isValid: true },
        { key: 'MSG_PASSWORD', configuration: { type: 'string' }, isDirty: false, isValid: true },
      ];
      newItems = MESSAGING_PROPERTIES.filter(item => !existingKeys.has(item.key)); // Filter out items with existing keys
      if (newItems.length < 1) {
        // Handle the case where all new items have existing keys
        this.props.showToastNotification(
          ToastType.Info,
          'All messaging properties (HOST_NAME, HOST_PORT...) already exist',
        );
        return;
      }
    }

    const list = this.state.confPropsMap ? this.state.confPropsMap.concat(newItems) : newItems;
    this.setState({ confPropsMap: list });

    if (this.props.inInitialState) {
      this.props.setInInitialState(false);
    }
  };

  handleListChange = (list: ConfProp[]) => {
    let changeInitialState = false;
    if (this.state.confPropsMap && this.state.confPropsMap.length > list.length) {
      changeInitialState = true;
    }
    this.setState({ confPropsMap: list });
    //set to false one after user modify property
    if (
      this.props.inInitialState === true &&
      (list.filter(cp => cp.isDirty === true).length > 0 || changeInitialState)
    ) {
      this.props.setInInitialState(false);
    }
  };

  render() {
    return (
      <div className="p-5">
        <ConfigurationPropertyList
          configurationProperties={this.state.confPropsMap}
          id={'list-' + this.props.configuration.id}
          handleAddNew={this.handleAddNewStringValue}
          onListChange={(list: ConfProp[]) => this.handleListChange(list)}
          onSave={this.props.onSave}
          invalidField={this.props.invalidField || this.props.inInitialState}
          inInitialState={this.props.inInitialState}
          dirtyPropsFound={this.props.dirtyPropsFound}
          resetDirtyPropsFound={this.props.resetDirtyPropsFound}
        />
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = {
  showToastNotification,
};
type DispatchProps = typeof mapDispatchToProps;
type AllProps = DispatchProps & ConfigurationDetailProps;

export default connect(mapStateToProps, mapDispatchToProps)(ConfigurationDetail);
